import {  Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";

import { handleSetNewsFilter } from "../ClientSideStates";

const Sorting = () => {
  const dispatch = useDispatch();
  const { filter } = useSelector((state: RootState) => state.news);

  const applySorterFilter = (value: string) => {
    const parsedKey = value.split("_");

    if (parsedKey.length === 2) {
      const [property, sortType] = parsedKey;

      // Sadece "asc" veya "desc" değerleri için işlem yapılmasını sağlar
      if (["asc", "desc"].includes(sortType)) {
        const newFilter = {
          SortProperty: property,
          SortType: sortType,
        };
        const allFilter = { ...filter, ...newFilter };

        dispatch(handleSetNewsFilter({ filter: allFilter }));
      }
    }
  };

  const options = [
     
    { value: "insertDate_desc", label: "Tarihe göre (Önce en yeni haber)" }, 
    { value: "insertDate_asc", label: "Tarihe göre (Önce en eski haber)" }, 
  ];

  return (
    <>
      <Select
        bordered={false}
        defaultValue={"insertDate_desc"} 
        className="!w-full"
        options={options}
        onChange={applySorterFilter} 
      />
     
    </>
  );
};

export default Sorting;
